import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import { XeroSettingsForm } from '../../../components/7DAY Admin Components/Xero/XeroSettingsForm';
import { useNavigate } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { XeroConnectionComponent } from '../../../components/7DAY Admin Components/Xero/XeroConnectionComponent';
import { useGetXeroConnectionQuery } from '../../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import UserRole from '../../../../shared/AuthRoles';

export const BillsAndInvoicesPage = () => {
    const { data: connection, isLoading } = useGetXeroConnectionQuery();

    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const loggedInUser = UserRole();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'billsAndInvoicesPage',
                },
            });
        }
    }, [loggedInUser.role]);

    const handleBackButton = () => {
        navigate('/adminCentre/host');
    };
    return isLoading ? (
        <LoadingComponent />
    ) : (
        <Box
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
            }}
        >
            <Stack height='100%' gap='40px'>
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    Bills and Invoices
                </Typography>
                <XeroConnectionComponent connection={connection} />
                <XeroSettingsForm connected={!!connection} />
            </Stack>

            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    marginLeft: !isMobile ? '-8px' : '-18px',
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />
                {isMobile ? null : (
                    <Typography
                        sx={{
                            fontSize: '12px',
                            paddingLeft: '5px',
                        }}
                    >
                        Back to Admin Centre
                    </Typography>
                )}
            </CustomButton>
        </Box>
    );
};
